export default __webpack_public_path__ + "static/diana-e0064c6c43cb4092f17a585ce398c294.png";